document.addEventListener("DOMContentLoaded", function () {
  // Nur Desktop
  if (window.innerWidth < 990) return;

  // Kategorien-Menü (links)
  const categoriesMenu = document.querySelector('[class*="categories"]');

  if (!categoriesMenu) return;

  // Nur Hunde-Eintrag anpassen
  const dogItem = categoriesMenu.querySelector('li');

  if (!dogItem) return;

  dogItem.addEventListener("mouseenter", () => {
    const allSubMenus = dogItem.querySelectorAll("ul ul");
    allSubMenus.forEach(menu => {
      menu.style.display = "block";
      menu.style.position = "static";
    });
  });
});
